import React from "react";
import { makeStyles } from "@mui/styles";
import { FontSize } from "src/const/font";

const useStyles = makeStyles((theme) => {
  return {
    styleDefault: {
      fontSize: FontSize.head.default,
      fontWeight: 600,
      lineHeight: "auto",
      color: theme.custom?.text.title,
      paddingTop: "24px",
      paddingBottom: "26px",
      [theme.breakpoints.down("md")]: {
        fontWeight: 700,
        textAlign: "left",
        paddingTop: "0px",
        paddingBottom: "20px",
        fontSize: FontSize.head.h3,
      },
    },
  };
});
interface PropsTextTitleI {
  style?: any;
  children: string | any;
  className?: string;
}

const SesstionTitle = (props: PropsTextTitleI) => {
  const { style, children, className } = props;
  const classes = useStyles();
  //! Render
  return (
    <>
      <p
        className={`${classes.styleDefault} ${className}`}
        style={{ ...style }}
      >
        {children}
      </p>
    </>
  );
};
export default SesstionTitle;
